import moment from 'moment'

export default function (value) {
	return moment(parseInt(value, 10)).utc().format('HH:mm:ss')
}
